import { Col, Image, Row } from "react-bootstrap";

const PhotoCard = (props) => {
    const {image} = props;
    return(
            <Image className="photo-card w-100" src={image}></Image>
    )
}
export default PhotoCard;